export default "__VITE_ASSET__CGzZKcyd__"